var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBuildingPerson({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1080_24664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5H8V12.5H10V8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.5H8V18.5H10V14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5H14V12.5H16V8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.5H14V18.5H16V14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 20.5H8V24.5H10V20.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20.5H14V24.5H16V20.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 27.5H18C16.3333 27.5 15 28.8467 15 30.5V32.5H17V30.5C17 29.9533 17.4533 29.5 18 29.5H24C24.5467 29.5 25 29.9533 25 30.5V32.5H27V30.5C27 28.8467 25.6533 27.5 24 27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 22.5C17 24.7133 18.7867 26.5 21 26.5C23.2133 26.5 25 24.7133 25 22.5C25 20.2867 23.2133 18.5 21 18.5C18.7867 18.5 17 20.2867 17 22.5ZM23 22.5C23 23.6067 22.1067 24.5 21 24.5C19.8933 24.5 19 23.6067 19 22.5C19 21.3933 19.9067 20.5 21 20.5C22.0933 20.5 23 21.4067 23 22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 22.5C30 20.2867 28.2133 18.5 26 18.5V20.5C27.0933 20.5 28 21.3933 28 22.5C28 23.6067 27.0933 24.5 26 24.5V26.5C28.2133 26.5 30 24.7133 30 22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 27.5H28V29.5H29C29.5467 29.5 30 29.9533 30 30.5V32.5H32V30.5C32 28.8467 30.6533 27.5 29 27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4.5H20V16.5H22V4.5C22 3.96667 21.7867 3.46 21.4133 3.08667C21.04 2.71333 20.5333 2.5 20 2.5H4C3.46667 2.5 2.96 2.71333 2.58667 3.08667C2.21333 3.46 2 3.96667 2 4.5V30.5H13V28.5H4V4.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1080_24664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBuildingPerson);
export default __webpack_public_path__ + "static/media/ic-building-person.a000ec72cf92b69f82464b4f4999833b.svg";
export { ForwardRef as ReactComponent };